export const PLACE_CATEGORY_TYPES = {
    Bar: 'Bar',
    Club: 'Club',
    Restaurant: 'Restaurant',
} as const;
export type PlaceCategoryTypes =
    (typeof PLACE_CATEGORY_TYPES)[keyof typeof PLACE_CATEGORY_TYPES];

export const PLACE_ANALYTICS_TYPES = {
    Details: 'Details',
    Nearby: 'Nearby',
} as const;
export type PlaceAnalyticsTypes =
    (typeof PLACE_ANALYTICS_TYPES)[keyof typeof PLACE_ANALYTICS_TYPES];

export const PLACE_FOLLOWING_TYPES = {
    Following: 'Following',
    Favorite: 'Favorite',
} as const;
export type PlaceFollowingTypes =
    (typeof PLACE_FOLLOWING_TYPES)[keyof typeof PLACE_FOLLOWING_TYPES];
